import React from 'react';
import PropTypes from 'prop-types';
import { PanelCards } from '../../../Panel';
import { HarvestCard } from '../../../cards/HarvestCard/HarvestCard';
import { FHA, PLANTING, WEATHER } from '../../../../constants/cards';

const CARDS = [WEATHER, PLANTING, FHA];

function HarvestPanel({ index, isCollapsed, isSplitViewEnabled }) {
  const isPreview = isSplitViewEnabled && isCollapsed;
  const firstCard = <HarvestCard index={index} isPreview={isPreview} />;

  return (
    <PanelCards
      cards={CARDS}
      firstCard={firstCard}
      index={index}
      isCollapsed={isCollapsed}
      testId="harvest"
    />
  );
}

HarvestPanel.propTypes = {
  index: PropTypes.number,
  isCollapsed: PropTypes.bool,
  isSplitViewEnabled: PropTypes.bool,
};

export default HarvestPanel;
